import React from 'react';
import classNames from 'classnames';
import { getXtramLogo } from '../../../assests/branding/xtram/logos';
import styles from './BrandXMark.module.css';

const ARMS = {
  tl: {
    fill: '#F9AA2A',
    d: 'M232.33,232.48c49.14-1.78,102.21-.51,151.5.47,14.58.29,37.07,35.98,45.43,47.58,40.71,56.56,80.84,113.59,122.38,169.53,10.1,13.59,18.46,29.51,1.34,38.2-2.33,1.16-4.94,1.71-7.52,1.71l-93.45.18c-21.01.11-43.4,1.2-64.19-1.53-5.85-.76-14.9-11.12-18.61-16.14-49.25-67.32-95.96-136.6-145.14-204.02-12.61-17.3-8.07-25.08,8.21-35.98h.04Z',
  },
  tr: {
    fill: '#FFFFFF',
    d: 'M645.86,232.84c38.57-.4,107.08-3.74,146.88,2.54,8.32,1.31,16.07,17.23,8.43,28.9-13.56,20.65-28.86,41.65-43.47,62.23-30.02,42.05-59.87,84.25-89.49,126.6-8.07,12.65-15.56,29.41-30.68,31-4.36.47-8.58-1.45-11.6-4.65-19.77-21.15-79.53-103.88-84.95-117.19,13.41-27.01,38.57-55.54,55.61-81.56,11.89-18.14,27.15-44.34,49.25-47.83v-.04Z',
  },
  bl: {
    fill: '#F9AA2A',
    d: 'M410.72,531.07c26.9-.22,120.78-3.96,145.36,3.53,2.11.65,3.93,1.96,5.23,3.74,1.93,2.58,2.94,5.09,2.76,9.01-.47,10.8-153.79,226.77-170.18,240.55-5.92.73-12.36,1.02-18.36,1.42-41.44.18-84.15,2.98-125.44.58-8.72-.51-21.01-1.6-26.97-8.87-3.56-4.36-5.38-9.05-4.43-14.79,1.09-6.43,135.9-197.88,151.06-217.69,4.76-6.22,9.7-11.52,16.03-16.25l24.9-1.24h.04Z',
  },
  br: {
    fill: '#FFFFFF',
    d: 'M625.76,538.89c1.93-2.14,4.69-3.38,7.56-3.38,5.27,0,10.07.51,13.49,4.58,7.89,9.41,15.38,20.28,22.5,30.24l44.89,62.88,57.25,79.38c4.87,6.72,10.14,14.9,15.3,21.23,55.83,68.01-14.68,57.03-69.13,58.59-16.03-.04-76.22.47-83.75-6.03-16.9-14.58-86.69-109.23-90.51-125.76,4.36-14.47,64.74-101.85,82.44-121.73h-.04Z',
  },
};

export default function BrandXMark({
  className,
  armClassNames = {},
  showLogo = false,
  logoSrc,
  logoAlt = 'Xtram',
  logoSurface = 'blue',
  busy = false,
}) {
  const svg = (
    <svg
      className={classNames(styles.svg, className, busy && styles.busy)}
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {Object.entries(ARMS).map(([key, arm]) => (
        <path key={key} className={armClassNames[key]} fill={arm.fill} d={arm.d} />
      ))}
    </svg>
  );

  if (!showLogo) return svg;

  return (
    <div className={styles.root}>
      {svg}
      <img
        src={logoSrc || getXtramLogo(logoSurface)}
        alt={logoAlt}
        className={styles.logo}
      />
    </div>
  );
}
